//@ts-nocheck
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {flowRight as compose} from 'lodash'
import {frontends} from '@bdswiss/common-enums'
import {getPlatform} from '../../../../common/utils'
import {withCreateDeposit, PaymentActionButton} from './helpers'

class KalixaProvider extends Component {

  state = {}

  doCreateDeposit() {
    const {account, providerProperties: {provider, paymentKey}, amount, onError, useVirtualPaymentPage, bonusAmount, bonusTerms} = this.props

    this.setState({creatingDeposit: true})

    const variables = {
      accountId: account.id,
      amount,
      vendor: provider,
      frontend: frontends.web2.value,
      args: JSON.stringify({
        platform: getPlatform(),
        paymentKey,
        useVirtualPaymentPage,
        bonusAmount,
        bonusTerms,
      }),
    }

    const newTab = window.open('about:blank', '_blank')

    this.props.createDepositRequest({variables})
      .then(({data: {newDeposit}}) => {
        const {payment: {url: paymentUrl}} = newDeposit
        newTab.location = paymentUrl
        this.setState({creatingDeposit: false})
      })
      .catch((e) => {
        newTab && newTab.close()
        this.setState({creatingDeposit: false})
        onError && onError(e)
      })
  }

  render() {
    const {creatingDeposit} = this.state
    return (
      <PaymentActionButton
        loading={creatingDeposit}
        onClick={() => this.doCreateDeposit()}
      />
    )
  }
}

KalixaProvider.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
  }).isRequired,
  providerProperties: PropTypes.shape({
    name: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
    paymentKey: PropTypes.string.isRequired,
  }).isRequired,
  amount: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
}

export default compose(
  withCreateDeposit
)(KalixaProvider)
